import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import React, { useState } from 'react'
import { tokens } from '../../../../theme'
import MoreVertIcon from '@mui/icons-material/MoreVert';

function ReadingCategoryBox({ readingCategory, editReadingCategory, removeReadingCategory }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const colors = tokens();
    return (
        <Box mt={"30px"} sx={{ gridColumn: "span 1" }} >
            <Menu
                id="menu"
                aria-labelledby="open-menu-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MenuItem onClick={() => {
                    handleClose();
                    editReadingCategory(readingCategory);
                }}>
                    Edit
                </MenuItem>
                <MenuItem onClick={() => {
                    removeReadingCategory(readingCategory);
                    handleClose()
                }}>
                    Remove
                </MenuItem>
            </Menu>

            <Box position="relative" bgcolor={colors.grey[900]} borderRadius="10px">
                <Box position="absolute" top={0} right={0}>

                    <IconButton
                        id="open-menu-button"
                        aria-controls={open ? 'menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}>
                        <MoreVertIcon sx={{ scale: "1.2" }} />
                    </IconButton>

                </Box>
                <Box display="flex" gap="10px">
                    <Box component={"img"} width="30%" src={readingCategory.thumbnail_link} borderRadius="10px 0 0 10px" />
                    <Box mt={"5px"} mr={"35px"}>
                        <Typography variant='h3' fontWeight="600" >
                            {readingCategory.title}
                        </Typography>
                        <Typography variant='h6' >
                            Number of readings: {readingCategory.reading_count}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default ReadingCategoryBox